/**
* Job List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Job List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'job-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.job-list__job-button' ).on( 'toggleAfter', function() {
        const content = $( this ).attr( 'data-toggle-content' );

        $( content ).stop().slideToggle( 500, 'swing' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'job-list', COMPONENT );
} )( app );
